window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
//CSRF TOKEN?
//window.Vue = require('vue');
import VueAuthenticate from "vue-authenticate";
import axios from "axios";
import VueAxios from "vue-axios";
import { baseUrl, google } from "./vars";
//const VueScript2 = require('vue-script2');
/*Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
    baseUrl: baseUrl, // Your API domain

    providers: {
        google
    }
})*/
import "./assets/styles/app.scss";
//require("!style!css!sass!./assets/styles/app.scss");

import Vue from "vue";
import Vuex from "vuex";
import { store } from "./store";
import { router } from "./router";
import Vuetify from "vuetify";
import VeeValidate, { Validator } from "vee-validate";
import pt_PT from "vee-validate/dist/locale/pt_PT";
const vueSmoothScroll = require("vue-smoothscroll");
const VueGoogleMaps = require("vue2-google-maps");
import VTooltip from "v-tooltip";

Vue.component("app-main", require("./pages/Main.vue").default); //WTF?

Vue.use(Vuetify, {
  theme: {
    primary: "#E90054",
    secondary: "#2d3256",
    accent: "#2d3256",
    error: "#ffffff",
    info: "#2196F3",
    success: "#63a563",
    warning: "#FFC107"
  }
});
Vue.use(VTooltip);
Vue.use(Vuex);
Vue.use(VeeValidate);
Vue.use(vueSmoothScroll);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBl_w8sFJDiONtBRB1ufaGaMdeO057RuDk",
    language: "pt-PT",
    region: "PT"
  }
});
Vue.use(require("vue-script2"));

Validator.localize("pt", pt_PT);

const app = new Vue({
  router,
  store,
  el: "#app"
});



// WEBPACK FOOTER //
// ./src/main.js